// useDimensions.tsx
// After mount, use an elements (via a passed ref) dimensions
import * as React from "react";
const {
  useState,
  useEffect
} = React;

const useDimensions = (ref, update) => {
  const [x, setX] = useState(null);
  const [y, setY] = useState(null);
  useEffect(() => {
    setX(ref.current.offsetWidth);
    setY(ref.current.offsetHeight);
  }, update);
  return [x, y];
};

export default useDimensions;